<template>
  <main class="m-t-70">
    <div class="page-headline m-b-30 m-t-70 align-center">
      <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
      <h4 class="tagline page-headline__tagline" v-html="pageInfo.content"></h4>
    </div>
    <div class="container-fluid">
      <fieldset v-for="project in projects" :key="project.id" class="section section__fieldset-project" v-bind:style="{ backgroundImage: 'url(' + project.feature_image_url + ')' }">
        <legend>{{ project.title }}</legend>
          <div class="row">
            <div class="col-md-7 col-xs-12">
              <div class="section__header">        
                <h1 class="headline section__header__headline">{{ project.title }}</h1>
                <p class="tagline section__header__tagline">{{ project.summary }}</p>      
                <div class="row">
                  <div class="col-md-4 col-xs-12">
                    <ul class="section__fieldset-project__details">
                      <li>{{ $t("project.projectType") }}</li>
                      <li>{{ project.project_type }}</li>
                    </ul>
                  </div>
                  <div class="col-md-4 col-xs-12">
                    <ul class="section__fieldset-project__details">
                      <li>{{ $t("project.clientName") }}</li>
                      <li>{{ project.client }}</li>
                    </ul>
                  </div>
                  <div class="col-md-4 col-xs-12">
                    <ul class="section__fieldset-project__details">
                      <li>{{ $t("project.liveVersion") }}</li>
                      <li v-if="project.site_url != ''">
                        <a target="_blank" rel="noopener" v-bind:href="project.site_url">
                          <i class="fa fa-globe" aria-hidden="true"></i>
                          {{ project.site_url }}
                        </a>
                      </li>
                      <li>
                        <a v-if="project.appstore_url != '' " class="icon-link" target="_blank" rel="noopener" v-bind:href="project.appstore_url">
                          <i class="fa fa-2x fa-apple" aria-hidden="true"></i>
                        </a>
                        <a v-if="project.playstore_url != ''" class="icon-link" target="_blank" rel="noopener" v-bind:href="project.playstore_url">
                          <i class="fa fa-2x fa-android" aria-hidden="true"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </main>
</template>

<script>
export default {
	name: "Projects",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			projects: []
		};
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getAll();
		this.getPageInfo();
	},
	methods: {
		getPageInfo() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/Pages?id=5")
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		},
		getAll() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/projects")
				.then(function(response) {
					this.projects = response.body;
				});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Projects.vue